module.exports = __webpack_public_path__ + "static/media/1.67c3d854.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/1.jpg
// module id = 1733
// module chunks = 0